<template>
    <div id="content_page">
        <v-layout row wrap>
            <v-flex xs0 sm0 md1 lg2 />
            <v-flex xs12 sm4 md4 lg3 class="custom_column custom_column_text">
                <h2>Une question ?</h2>
                <p>
                    Une demande spécifique ?
                    <br> Besoin d'aide ou, simplement faire un retour sur l'admin de Blinkl ?
                    <br>N'hésitez pas à nous contacter grâce à ce formulaire.
                </p>
            </v-flex>
            <v-flex xs12 sm8 md6 lg5 class="custom_column custom_column_form">
                <v-text-field v-model="$v.contact.first_name.$model"
                              :error-messages="!!$v.contact.first_name.$error ? 'Veuillez saisir votre prénom': ''"
                              label="Prénom" placeholder="Prénom" filled maxlength="55" />

                <v-text-field v-model="$v.contact.last_name.$model"
                              :error-messages="!!$v.contact.last_name.$error ? 'Veuillez saisir votre nom': ''"
                              label="Nom" placeholder="Nom" filled maxlength="55" />

                <v-text-field v-model="$v.contact.mail.$model"
                              :error-messages="!!$v.contact.mail.$error ? 'Veuillez saisir votre mail': ''"
                              label="Email" placeholder="Email" filled maxlength="255" />

                <v-text-field v-model="$v.contact.phone.$model"
                              :error-messages="!!$v.contact.phone.$error ? 'Veuillez saisir votre numéro de téléphone': ''"
                              label="Phone" placeholder="Phone" filled type="phone" maxlength="10" />

                <v-textarea v-model="$v.contact.message.$model"
                            :error-messages="!!$v.contact.message.$error ? 'Veuillez saisir votre message': ''"
                            label="Message" placeholder="Message" filled />
                <v-flex xs6 sm3>
                    <v-btn class="custom_btn_position custom_btn_color_blue"
                           :disabled="!$v.contact.$anyDirty || $v.contact.$invalid"
                           @click="submit(contact.message)">
                        <i class="fa fa-check" />Envoyer
                    </v-btn>
                </v-flex>
            </v-flex>
            <v-flex xs0 sm0 md1 lg2 />
        </v-layout>
    </div>
</template>

<script>

    import { required, maxLength, minLength, numeric } from 'vuelidate/lib/validators';
    import axios from 'axios';

    export default {
        name: 'Contact',
        validations: {
            contact: {
                first_name: { required, maxLength: maxLength(55) },
                last_name: { required, maxLength: maxLength(55) },
                mail: { required, maxLength: maxLength(255), minLength: minLength(5) },
                phone: { required, numeric, maxLength: maxLength(10), minLength: minLength(10) },
                message: { required }
            }
        },
        data: () => ({
            contact: {
                first_name: '',
                last_name: '',
                mail: '',
                phone: '',
                message: ''
            }
        }),
        methods: {
            submit: function () {
                axios.post('/contact', { message: this.contact.message }).then(
                    () => {
                        this.$toasted.success('Email envoyé, nous vous répondrons au plus vite.');
                    }, (err) => {
                        this.$toasted.error(err);
                    }
                );
            }
        }
    };
</script>

<style lang="scss" scoped>

    #content_page {
        padding: 20px;
    }

    .custom_column {
        padding: 10px !important;
    }

    .custom_column h1, .custom_column p {
        text-align: left;
    }

    .custom_column_form {
        text-align: left;
        border-radius: 5px;
        background-color: #FFF;
    }

    #contactBody .label {
        font-weight: 500;
    }

</style>
